const controlVideo = () => {
    const sections = document.querySelectorAll('.section-side-by-side') ;

    if (sections.length === 0) {
        return;
    }

    sections.forEach(section => {
        const video = section?.querySelector('video');

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    video?.play();
                } else {
                    video?.pause();
                }
            });
        });

        observer.observe(video);
    })
}
document.addEventListener('DOMContentLoaded', controlVideo);